import React from 'react';
import { throttle } from '../util/decorators';
import pubSub from '../util/pubSub';
import Loader from './Loader';
import { appContext } from '../util/decorators';

// how many pixels before we reach the bottom of the measured element we should lazy load
const INFINITE_SCROLL_LOAD_DISTANCE = 1500;

@appContext
export default class InfiniteScrollLoader extends React.PureComponent {
  componentDidMount() {
    this.scrollSubscription = pubSub.subscribe('scroll', () => this.scrollHandler());
  }

  componentWillUnmount() {
    this.scrollSubscription.remove();
  }

  @throttle(750)
  scrollHandler() {
    const { lastRequestedOffset, loadedOffset, loadMore } = this.props;

    const isCloseToBottom = document.querySelector('body').getBoundingClientRect().bottom - window.innerHeight < INFINITE_SCROLL_LOAD_DISTANCE;

    if (isCloseToBottom && lastRequestedOffset <= loadedOffset) {
      const promise = loadMore();
      if (promise) {
        this.setState({loading: true});
        promise.then(() => this.setState({loading: false}));
      }
    }
  }

  render() {
    const { lastRequestedOffset, loadedOffset } = this.props;

    const loading = this.state && this.state.loading;

    if (loading) {
    //console.log(`loading1` );
      return <Loader className="loader loader-small" />;
    }
//console.log(`loading` );
    if (lastRequestedOffset > loadedOffset && loadedOffset > 0) {
      return <div className="no-more-articles">{this.context.app.t('InfiniteScroll.no_more_articles')}</div>;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/component/InfiniteScrollLoader.jsx